import { useSyncExternalStore } from "react";

// A shop website (Provider Shop) registers ITS navigation for the Elakay menu drawer (☰), which shows
// it on small screens where the shop header keeps only Home / Search / Menu. Same tiny external-store
// pattern as drawerFilterSlot: page and drawer are siblings under Layout.
//   { owner, title, sections: [{ key, label, items: [{ key, label, to?, onClick?, icon?, inert? }] }] }
let slot = null;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export const setDrawerShopNav = (next) => { slot = next; emit(); };
export const clearDrawerShopNav = (owner) => { if (!owner || slot?.owner === owner) { slot = null; emit(); } };
export const useDrawerShopNav = () => useSyncExternalStore((cb) => { listeners.add(cb); return () => listeners.delete(cb); }, () => slot);
